import {
  CasLoaderWithBackdrop,
  CasErrorDisplay,
  CasReactHookFormDialog,
} from 'src/compass/shared/components';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { useRetrieveDetailsById } from 'src/compass/shared/hooks/reactQuery/useRetrieveDetailsById';
import OwnerForm from './OwnerForm';
import { OwnersSchema } from './OwnersSchema';

type OwnerDialogProps = {
  id: number;
  onClose: VoidFunction;
}

export default function OwnerDialog({ id, onClose }: OwnerDialogProps) {
  const { data, isFetching, isError } = useRetrieveDetailsById({
    entity: `Utilities/Owner`,
    id,
    enabled: !!id,
  });

  const mutation = useUpdateMutation({
    url: 'Utilities/Owner',
    onSuccess: (successData) => {
      onSuccessEnqueueSnackbar(successData);
      onClose();
    },
  });

  const { mutate, isPending } = mutation;

  const saveEntity = (entityData: any) => {
    const { entityObj, ...rest } = entityData;
    mutate({ ...rest, entityId: entityObj.id });
  };

  if (isFetching) return <CasLoaderWithBackdrop />;

  if (isError) return <CasErrorDisplay message="Error retrieving data from the server." />;

  return (
    <CasReactHookFormDialog
      open
      onClose={onClose}
      title="Edit Owner"
      submitButtonLabel="Update"
      defaultValues={data}
      onSubmit={saveEntity}
      schema={OwnersSchema}
    >
      {isPending && <CasLoaderWithBackdrop />}
      <OwnerForm row={data} />
    </CasReactHookFormDialog>
  );
}
